// extracted by mini-css-extract-plugin
export default {"modal-overlay":"styles_modal-overlay__QdUW3","modal-content":"styles_modal-content__Wuiw7"};